module.exports = __webpack_public_path__ + "../static/img/synapse_logo.c997e6df.png";